import STRINGS from '@/consts/strings'
// import apiRequest from '@/helpers/apiRequests'
// import endpoints from '@/consts/endpoints'

const state = {
  sawEntrance: false,
  showNavbar: true,
  menuVisibleWhileMobile: false,
  lang: 'pl',
  strings: STRINGS.pl
}

const getters = {
  sawEntrance: state => state.sawEntrance,
  showNavbar: state => state.showNavbar,
  menuVisibleWhileMobile: state => state.menuVisibleWhileMobile,
  lang: state => state.lang,
  strings: state => state.strings
}

const mutations = {
  setSawEntrance: state => {
    state.sawEntrance = true
  },
  toggleShowNavbar: state => {
    state.showNavbar = !state.showNavbar
  },
  toggleMenuVisibleWhileMobile: state => {
    state.menuVisibleWhileMobile = !state.menuVisibleWhileMobile
  },
  hideMenuWhenMobile: state => {
    state.menuVisibleWhileMobile = false
  },
  setLang: (state, lang) => {
    state.lang = lang
  },
  setStrings: (state, lang) => {
    state.strings = STRINGS[lang]
  }
}

const actions = {
  setSawEntrance: ({ commit }) => {
    commit('setSawEntrance')
  },
  toggleShowNavbar: ({ commit }) => {
    commit('toggleShowNavbar')
  },
  toggleMenuVisibleWhileMobile: ({ commit }) => {
    commit('toggleMenuVisibleWhileMobile')
  },
  hideMenuWhenMobile: ({ commit }) => {
    commit('hideMenuWhenMobile')
  },
  setLang: ({ commit }, lang) => {
    commit('setLang', lang)
    commit('setStrings', lang)
  }
  // sendAgreement: async ({ commit }, data) => {
  //   const result = await apiRequest.post(endpoints.agreement, data, {
  //     responseType: 'blob'
  //     // headers: {
  //     //   'Content-Type': 'application/json',
  //     //   Accept: 'application/pdf'
  //     // }
  //   })
  //     .then((response) => {
  //       const url = window.URL.createObjectURL(new Blob([response.data]))
  //       const link = document.createElement('a')
  //       link.href = url
  //       link.setAttribute('download', 'file.pdf') // or any other extension
  //       document.body.appendChild(link)
  //       link.click()
  //     })
  //     .catch((error) => console.log(error))
  //   return result
  // }
}

export default {
  state,
  getters,
  actions,
  mutations
}
